<script>
import { dataset_dev } from "svelte/internal";
import { options } from "../config";
import { PostContact } from "../Services/form0";
import { user } from "../store";

let data = {
    profile:options.profile,
    form:"qrcode_maker",
    data:{

    }
}

const save = ()=>{
    PostContact(data,$user.idToken,(result)=>{data=result},error=>{console.log("error")})
}

</script>

<input type="url" bind:value={data.data.url}>
<a on:click={()=>save()}>Generate</a>
{#if data?.qrcode}
    <img src={data.qrcode}/>
{/if}